import { Funnel } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const FilterIcon = DeckardIconWrapper({ Icon: Funnel });
